import React from 'react';
import {useState, useEffect, useRef} from 'react';
import './Datepicker.css';
import Month from './Month.jsx'
import { getMonthsBetween } from '../../lib/helpers.js';

// start date, end date should in format 'YYYY-mm-dd'
// activeDates: {'2025-01-30': 1, '2025-02-20': 1}  
// or {'any' : true}  which is used together with startDate and endDate to make all dates active.
function Datepicker({
    startDate,
    endDate,
    monthTexts,
    weekDayTexts,
    activeDates,
    dateLegnedAvailable,
    dateLegnedUnavailable,
    show,
    onClose,
    onDatePicked,
    onOverlayPicked,
    selectedDate,
    selectedDateBackgroundColor,
    selectedDateColor,
}) {
    const overlayRef = useRef(null);
    let rtl = document.querySelector('body').classList.contains('rtl');

    let months = [];
    if (endDate) {
        //months = [[9, 2025], [10, 2025], [11, 2025]];     // month starts with 0
        months = getMonthsBetween(startDate, endDate);
    
    } else {
        let startDateSplit = startDate.split('-');
        startDateSplit[2] = 15;                         // set to mid of the month to avoid timezone changes month issue. we are to show the dates in the whole month. saft to set it to 15.
        startDate = startDateSplit.join('-');
        let monthsToShow = 6;
        let currentDate = new Date(startDate);
        
        for (let i = 0; i < monthsToShow; i++) {
            months.push([currentDate.getMonth(), currentDate.getFullYear()]);
            currentDate.setMonth(currentDate.getMonth() + 1);
        }
    }

    function datepickerOverlayClicked(e) {
        onOverlayPicked(e);
    }

    // direction: -1 for left, 1 for right
    function _move(direction){
        let overlay = overlayRef.current;
        let leftArrow = overlay.querySelector('.leftarrow');
        let rightArrow = overlay.querySelector('.rightarrow');
        let monthsContainer =  overlay.querySelector('.months_container');
        let monthDiv = overlay.querySelector('.month_ra_container');
        let movingCssClass = 'moving';
        
        if ([overlay, leftArrow, rightArrow, monthsContainer, monthDiv].indexOf(null) >= 0) {
            return;
        }
        
        if (leftArrow.classList.contains(movingCssClass)) {
            return;
        }
        
        leftArrow.classList.add(movingCssClass);
        rightArrow.classList.add(movingCssClass);
        
        let monthsWidth = monthsContainer.offsetWidth;
        let fullContentWidth = monthsContainer.scrollWidth;
        let gap = parseInt(window.getComputedStyle(monthsContainer).getPropertyValue('gap'), 10);
        let oldScrollLeft = monthsContainer.scrollLeft;
        
        let width = monthDiv.offsetWidth
        let newScrollLeft = oldScrollLeft + (width + gap) * direction;
        
        monthsContainer.scrollTo({left: newScrollLeft,behavior: 'smooth'});

        setTimeout(function(){
            leftArrow.classList.remove(movingCssClass);
            rightArrow.classList.remove(movingCssClass);
        }, 500)
        
        let allowedError = 10;
        let maxScrollLeft = fullContentWidth - monthsWidth;

        if (rtl) {
            if (newScrollLeft < -1 *  maxScrollLeft + allowedError) {
                console.log('d')
                leftArrow.style.display = 'none';
                rightArrow.style.display = 'inline-block';
            }
            else if (Math.abs(newScrollLeft) < allowedError) {
                console.log('e')
                leftArrow.style.display = 'inline-block';
                rightArrow.style.display = 'none';
            }
            else {
                console.log('f')
                leftArrow.style.display = 'inline-block';
                rightArrow.style.display = 'inline-block';
            }
        
        
        } else {

            if (newScrollLeft < allowedError) {
                console.log('a')
                leftArrow.style.display = 'none';
                rightArrow.style.display = 'inline-block';
            }
            else if (newScrollLeft > maxScrollLeft - allowedError) {
                console.log('b')
                leftArrow.style.display = 'inline-block';
                rightArrow.style.display = 'none';
            }
            else {
                console.log('c')
                leftArrow.style.display = 'inline-block';
                rightArrow.style.display = 'inline-block';
            }
        }

    }

    function onMoveLeft(){
        _move(-1);
    }

    function onMoveRight(){
        _move(1);
    }

    /*
    useEffect(() => {
        console.log('zzz',  $('.months_container').scrollLeft());
        let $overlay = $(overlayRef.current);
        let scrollleft =  $overlay.find('.months_container').scrollLeft();
        let allowedError = 10;

        let $leftArrow = $overlay.find('.leftarrow');
        let $rightArrow = $overlay.find('.rightarrow'); 

        if (scrollleft < allowedError) {
            $leftArrow.hide();
            $rightArrow.show();
        }
        else if (scrollleft > 600 - allowedError) {
        }
        else {
            $leftArrow.show();
            $rightArrow.show();
        }
    }, [scrollLeft]);
    */

   
    return (
        <div className={`datepicker_ra_overlay ifonly_overlay ${SG.F_BODY}`} ref={overlayRef} style={{display: (show ? 'block' : 'none'), overflowY: 'visible'}} onClick={datepickerOverlayClicked}>
            <div className={`ifonly_pop ${SG.RC_BD_RADIUS}`} >
                <div className='months_container'>
                    {
                        months.map((m, i) => { return (
                            <Month 
                                year={m[1]}
                                month={m[0]}
                                monthTexts={monthTexts}
                                weekDayTexts={weekDayTexts}
                                key={i}
                                onDatePicked={onDatePicked}
                                selectedDate={selectedDate}
                                activeDates={activeDates}
                                selectedDateBackgroundColor = {selectedDateBackgroundColor}
                                selectedDateColor = {selectedDateColor}
                                startDate={startDate}
                                endDate={endDate}
                            />
                        )})
                    }
                </div>

                <button type="button" className="closebtn" onClick={() => onClose(false)} >
                    <svg  width="30" height="30" viewBox="0 0 500 500" fill="none" xmlns="http://www.w3.org/2000/svg" >
                        <title>Close</title>
                        <g clipPath="url(#clip0_99_372)">
                        <path fillRule="evenodd" clipRule="evenodd" d="M273.759 250.425L376.237 352.902L352.902 376.237L250.425 273.759L147.947 376.237L124.613 352.902L227.09 250.425L124.613 147.947L147.947 124.613L250.425 227.09L352.902 124.613L376.237 147.947L273.759 250.425Z" />
                        </g>
                        <defs>
                        <clipPath id="clip0_99_372">
                        <rect width="500" height="500" />
                        </clipPath>
                        </defs>
                    </svg>
                </button>

                <button type="button" className="leftarrow arrow" onClick={onMoveLeft} style={{display: rtl ? 'inline-block':'none'}} >
                    <svg  width="13" height="40" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg" >
                        <title>Previous Month</title>
                        <path d="M12 1L2 11L12 21"  strokeWidth="2"></path>
                    </svg>
                </button>

                <button type="button" className="rightarrow arrow" onClick={onMoveRight} style={{display: rtl ? 'none' : 'inline-block'}} >
                    <svg  width="13" height="40" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg" >
                        <title>Next Month</title>
                        <path d="M1 1L11 11L1 21"  strokeWidth="2"></path>
                    </svg>
                </button>

                <div className="date_legend">
                    <div>
                        <button 
                            type="button" className={"clean_button rtp_date_cell not_empty active " + SG.BD_PRIMARY} 
                            style={{backgroundColor: 'transparent'}}
                            tabIndex="-1"
                        >
                            &nbsp;
                        </button>
                        <span style={{color: 'white'}}>{dateLegnedAvailable}</span>
                    </div>
                    <div>
                        <button type="button" className="clean_button rtp_date_cell not_empty " tabIndex="-1" >&nbsp;</button>
                        <span style={{color: 'white'}}>{dateLegnedUnavailable}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Datepicker;
